import { render, staticRenderFns } from "./rewritelogs.vue?vue&type=template&id=52fb78f3&scoped=true&"
import script from "./rewritelogs.vue?vue&type=script&lang=js&"
export * from "./rewritelogs.vue?vue&type=script&lang=js&"
import style0 from "./rewritelogs.vue?vue&type=style&index=0&id=52fb78f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb78f3",
  null
  
)

export default component.exports